interface IconProps {
  width?: string;
  height?: string;
  className?: string;
}

const UsersIcon = ({ width = "20", height = "20", className = "" }: IconProps) => {
  return (
    <span className={className}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.0004 5.96663C14.9504 5.9583 14.8921 5.9583 14.8421 5.96663C13.6921 5.92496 12.7754 4.98329 12.7754 3.81663C12.7754 2.62496 13.7337 1.66663 14.9254 1.66663C16.1171 1.66663 17.0754 2.63329 17.0754 3.81663C17.0671 4.98329 16.1504 5.92496 15.0004 5.96663Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.1422 12.0333C15.2839 12.225 16.5422 12.025 17.4255 11.4333C18.6005 10.65 18.6005 9.36664 17.4255 8.58331C16.5339 7.99164 15.2589 7.79163 14.1172 7.99163"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.97344 5.96663C5.02344 5.9583 5.08177 5.9583 5.13177 5.96663C6.28177 5.92496 7.19844 4.98329 7.19844 3.81663C7.19844 2.62496 6.24011 1.66663 5.04844 1.66663C3.85677 1.66663 2.89844 2.63329 2.89844 3.81663C2.90677 4.98329 3.82344 5.92496 4.97344 5.96663Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.83255 12.0333C4.69088 12.225 3.43255 12.025 2.54922 11.4333C1.37422 10.65 1.37422 9.36664 2.54922 8.58331C3.44089 7.99164 4.71588 7.79163 5.85755 7.99163"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.0004 12.1917C9.95039 12.1834 9.89206 12.1834 9.84206 12.1917C8.69206 12.1501 7.77539 11.2084 7.77539 10.0417C7.77539 8.85006 8.73372 7.89172 9.92539 7.89172C11.1171 7.89172 12.0754 8.85839 12.0754 10.0417C12.0671 11.2084 11.1504 12.1584 10.0004 12.1917Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.57461 14.8167C6.39961 15.6 6.39961 16.8833 7.57461 17.6667C8.90794 18.5583 11.0913 18.5583 12.4246 17.6667C13.5996 16.8833 13.5996 15.6 12.4246 14.8167C11.0996 13.9333 8.90794 13.9333 7.57461 14.8167Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

export default UsersIcon;